export default __webpack_public_path__ + "media/images/elephant-fren-2e889499548a61dac8b5d7858f056f64-777333bedb81fa74fe0916905912ad9f.png";